import type { SessionUser } from '@his/shared';

const SHARE_SCREENS = new Set(['/accounts/doctor-share', '/accounting/payouts']);

export function reachableBranchIds(user: Pick<SessionUser, 'branches' | 'feeSplittingByBranch'>): string[] {
  const all = Object.keys(user.feeSplittingByBranch ?? {});
  if (!user.branches || user.branches.length === 0) return all;
  return user.branches.map((branch) => branch.id).filter((id) => all.includes(id));
}

export function feeSplittingOnAnywhere(user: Pick<SessionUser, 'branches' | 'feeSplittingByBranch'>): boolean {
  const byBranch = user.feeSplittingByBranch;
  if (!byBranch) return true;
  const reachable = reachableBranchIds(user);
  if (reachable.length === 0) return true;
  return reachable.some((id) => byBranch[id] !== false);
}

export function hidesShareScreens(user: Pick<SessionUser, 'branches' | 'feeSplittingByBranch' | 'shareHistory'>, path: string): boolean {
  if (!SHARE_SCREENS.has(path)) return false;
  return !feeSplittingOnAnywhere(user) && user.shareHistory === false;
}

export function feeSplittingOnFor(user: Pick<SessionUser, 'feeSplittingByBranch'>, branchId: string | null | undefined): boolean {
  if (!branchId || !user.feeSplittingByBranch) return true;
  return user.feeSplittingByBranch[branchId] !== false;
}
